// Externe Bibliotheken
import { useContext, useEffect } from 'react';

// Interne Module
import * as storage from '@/_helper/storage';
import { globalParams } from '@/_config/globalParams';
import { AppContext } from '@/context/AppContext.tsx';

export const AutoLogout = ({ children }) => {
    const { logout: appLogout } = useContext(AppContext);
    let autoLogoutTime = globalParams.autoLogoutTime;
    const specialLogout = storage.get('autoLogoutInsteadOfRefreshLogin');

    useEffect(() => {
        const logic = () => {
            if (storage.get('access_token') !== null) {
                let loginTime = storage.get('login_timestamp');
                let currentTime = new Date().getTime();
                let remainingTime = autoLogoutTime - (new Date().getTime() - storage.get('login_timestamp'));

                if (storage.get('setAutoLogoutTimer')) {
                    storage.set('setAutoLogoutTimer', true);
                }

                setTimeout(() => {
                    if (!storage.get('access_token')) {
                        return;
                    }
                    currentTime = new Date().getTime();
                    loginTime = storage.get('login_timestamp');
                    if (currentTime - loginTime >= autoLogoutTime) {
                        autologout();
                    }
                }, remainingTime);
            }
        };
        logic();

        return () => {
            logic();
        };
    });

    const autologout = () => {
        appLogout(true);
    };

    if (specialLogout) {
        autoLogoutTime = 0;
        autologout();
    }

    return children;
};
